import React, { useState, useEffect } from 'react';

const sleeveOptions = [
  '30', '30.5', '31', '31.5', '32', '32.5',
  '33', '33.5', '34', '34.5', '35', '35.5',
  '36', '36.5', '37'
];

const StepSleeveLength = ({ data, setData, onNext, onPrev }) => {
  const [customLength, setCustomLength] = useState('');

  const handleSelect = (length) => {
    setData(prev => ({
      ...prev,
      sleeveLength: length
    }));
    setCustomLength('');
  };

  const handleCustomChange = () => {
    if (customLength) {
      setData(prev => ({
        ...prev,
        sleeveLength: customLength
      }));
    }
  };

  const handleSkip = () => {
    setData(prev => ({
      ...prev,
      sleeveLength: null
    }));
    onNext();
  };

  // ✅ Pre-fill if sleeveLength is custom
  useEffect(() => {
    const isCustom = data.sleeveLength && !sleeveOptions.includes(data.sleeveLength);
    if (isCustom) {
      setCustomLength(data.sleeveLength);
    }
  }, [data.sleeveLength]);

  return (
    <main className="rbt-main-wrapper">
      <div className="container custom-checkout-container">
        <div className="row">
          <div className="">
            <div className="sleeve-selection-container">
              <h3 className="sleeve-selection-title">What is your sleeve length?</h3>

              <div className="sleeve-selection-grid selection-grid">
                {sleeveOptions.map(option => (
                  <button
                    key={option}
                    className={`selection-btn ${data.sleeveLength === option ? 'active' : ''}`}
                    onClick={() => handleSelect(option)}
                  >
                    {option}
                  </button>
                ))}
              </div>

              <div className="custom-height mt-3">
                <label>Custom length:</label>
                <input
                  type="text"
                  placeholder="in"
                  value={customLength}
                  onChange={(e) => setCustomLength(e.target.value)}
                  onBlur={handleCustomChange}
                />
              </div>

              <button className="skip-btn mt-3" onClick={handleSkip}>
                I'm not sure, skip this question
              </button>

              <div className="nav-buttons mt-4">
                <button className="selection-prev-btn" onClick={onPrev}>
                  Prev
                </button>
                <button
                  className="selection-next-btn"
                  onClick={onNext}
                  disabled={!data.sleeveLength}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default StepSleeveLength;
